// import { APP_SETTINGS_API } from "../../../../Utilities/APIs/APIs"
// import BINCRUD from "../../../Partials/Layouts/CRUDs/CRUDLayouts/BINCRUD/BINCRUD"

import { useContext, useState } from "react"
import AppContext from "../../../../AppContext/AppContext"
import useAxiosInstance from "../../../../Utilities/Hooks/useAxiosInstance"
import { useNavigate } from "react-router-dom"
import { useEffect } from "react"
import { AMANAGE_APP_SETTING_API, APP_SETTINGS_API, IMAGE_URL } from "../../../../Utilities/APIs/APIs"
import CreateButton from "../../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDDashboardBoilerplate/CRUDHeader/CreateButton/CreateButton"
import CRUDTable from "../../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDTableBoilerPlate/CRUDTable/CRUDTable"
import CRUDTableHeader from "../../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDTableBoilerPlate/CRUDTable/CRUDTableHeader/CRUDTableHeader"
import CRUDth from "../../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDTableBoilerPlate/CRUDTable/CRUDTableHeader/CRUDth/CRUDth"
import CRUDTableRow from "../../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDTableBoilerPlate/CRUDTable/CRUDTableRow/CRUDTableRow"
import ShortTextCell from "../../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDTableBoilerPlate/CRUDTable/CRUDTableCells/ShortTextCell/ShortTextCell"
import ViewButton from "../../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDTableBoilerPlate/CRUDButtons/ViewButton/ViewButton"
import EditButton from "../../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDTableBoilerPlate/CRUDButtons/EditButton/EditButton"
import DeleteButton from "../../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDTableBoilerPlate/CRUDButtons/DeleteButton/DeleteButton"
import CRUDButton from "../../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDTableBoilerPlate/CRUDButtons/CRUDButton"
import { RiImage2Line } from "react-icons/ri"
import Modal from "../../../Partials/Elements/Modal/Modal"
import DeleteItem from "../../../Partials/Layouts/DeleteItem/DeleteItem"
import CreateAppSettings from "./CreateAppSettings"
import ImageCell from "../../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDTableBoilerPlate/CRUDTable/CRUDTableCells/ImageCell/ImageCell"
import ViewAppSettings from "./ViewAppSettings"
import UpdateAppSettings from "./UpdateAppSettings"

// function AppSettings() {
//   return (
//     <BINCRUD
//         // common props
//         api = {APP_SETTINGS_API + 'manageAppSettings/'}
//         screenTopicSingular = 'App Setting'
//         screenTopicPlural = 'App Settings'
        
//         // crud props
//         allowUpdate
        
//         // field props
//         booleanDBField='isCategoryFeatured'
//         booleanName='Is Category Featured?'
//     />
//   )
// }

// export default AppSettings





function AppSettings() {

    const [appSettings, setAppSettings] = useState(null)
    const [showModal, setShowModal] = useState(false)
    const [targetID, setTargetID] = useState(null)
    const [showViewSection, setShowViewSection] = useState(false)
    const [showCreateForm, setShowCreateForm] = useState(false)
    const [showUpdateForm, setShowUpdateForm] = useState(false)
    const [showDeleteSection, setShowDeleteSection] = useState(false)
    const [toggleFetch, setToggleFetch] = useState(false)
    const { employee } = useContext(AppContext)

    const axiosInstance = useAxiosInstance()
    const navigate = useNavigate()

    useEffect(() => {

        async function fetchAndSetCategories() {
            const { data } = await axiosInstance.get(AMANAGE_APP_SETTING_API)
          setAppSettings(data)
        }
        fetchAndSetCategories()


    }, [toggleFetch, axiosInstance])

    function handleClose() {
        setShowModal(false);
        setShowCreateForm(false);
        setShowViewSection(false);
        setShowUpdateForm(false);
        setShowDeleteSection(false);
    }

    function triggerFetch() {
        setToggleFetch(prevState => !prevState)
    }


    return (
        <>
            <div className='crud_holder'>
                <div className="body_header">
                    <h1 className="heading">{`App Settings (${appSettings?.length} in total)`}</h1>
                    <CreateButton
                        screenTopicSingular='App Settings'
                        setShowModal={setShowModal}
                        setShowCreateForm={setShowCreateForm}
                    />
                </div>
                <CRUDTable>
                    <CRUDTableHeader>
                        <CRUDth th='Name' />
                        <CRUDth th='Image' />
                        <CRUDth th='Actions' />
                    </CRUDTableHeader>
                    <tbody>
                        {appSettings?.map(appSetting => (
                            <CRUDTableRow key={appSetting._id}>
                                <ShortTextCell text={appSetting?.name} />
                                <ImageCell imgSrc={IMAGE_URL + appSetting.image} alt={appSetting.name} />

                                <td className="action_button_cell">
                                    <ViewButton
                                        setShowModal={setShowModal}
                                        setShowViewSection={setShowViewSection}
                                        targetID={appSetting._id}
                                        setTargetID={setTargetID}
                                    />
                                    <EditButton
                                        setShowModal={setShowModal}
                                        setShowUpdateForm={setShowUpdateForm}
                                        targetID={appSetting._id}
                                        setTargetID={setTargetID}
                                    />
                                    <DeleteButton
                                        setShowModal={setShowModal}
                                        setShowDeleteSection={setShowDeleteSection}
                                        targetID={appSetting._id}
                                        setTargetID={setTargetID}
                                    />

                                </td>
                            </CRUDTableRow>
                        ))}
                    </tbody>
                </CRUDTable>
            </div>
            {showModal &&
                <Modal
                    view
                    handleClose={handleClose}
                    modalHeading={
                        (showCreateForm && `Create App Settings`) ||
                        (showUpdateForm && `Update App Settings`) ||
                        (showDeleteSection && `Delete App Settings`)
                    }
                >
                    {
                        showCreateForm &&
                        <CreateAppSettings
                            employee={employee}
                            setShowCreateForm={setShowCreateForm}
                            setShowModal={setShowModal}
                            triggerFetch={triggerFetch}
                        />
                    }
                    {
                        showUpdateForm &&
                        <UpdateAppSettings
                            employee={employee}
                            targetID={targetID}
                            setShowUpdateForm={setShowUpdateForm}
                            setShowModal={setShowModal}
                            triggerFetch={triggerFetch}
                        />
                    }

                    
                    {
                        showDeleteSection &&
                        <DeleteItem
                            api={AMANAGE_APP_SETTING_API}
                            targetID={targetID}
                            employee={employee}
                            setShowModal={setShowModal}
                            setShowDeleteSection={setShowDeleteSection}
                            hasName
                            triggerFetch={triggerFetch}
                        />
                    }
                </Modal>
            }

            {showModal && showViewSection &&
                <Modal
                    view
                    handleClose={handleClose}
                    modalHeading={
                        (showViewSection && `View App Settings`)
                    }
                >
                    <ViewAppSettings
                        targetID={targetID}
                        employee={employee}
                    />
                </Modal>
            }
        </>
    )
}

export default AppSettings